module.exports = __webpack_public_path__ + "static/media/popup-close.c7436a93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/popup-close.svg
// module id = 102
// module chunks = 0